import React from 'react';
import { IconButton, Stack, Tooltip } from '@mui/material';
import {
  Twitter as TwitterIcon,
  Telegram as TelegramIcon,
  Instagram as InstagramIcon,
  YouTube as YouTubeIcon,
} from '@mui/icons-material';
import { SiDiscord } from 'react-icons/si';
import { theme, commonStyles } from '../../styles/theme';

// Map icon names from database to actual icon components
const iconMap = {
  'Twitter': TwitterIcon,
  'DiscordIcon': SiDiscord,
  'TelegramIcon': TelegramIcon,
  'Instagram': InstagramIcon,
  'Youtube': YouTubeIcon,
};

const SocialLinks = ({ links, color = 'inherit', size = 'medium', spacing = 1 }) => {
  if (!links || links.length === 0) return null;

  return (
    <Stack direction="row" spacing={spacing} alignItems="center">
      {links.map((link) => {
        const IconComponent = iconMap[link.icon_name];
        if (!IconComponent) return null;

        return (
          <Tooltip key={link.id} title={link.aria_label || link.name}>
            <IconButton
              component="a"
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link.aria_label || link.name}
              size={size}
              sx={{
                color: color,
                transition: 'all 0.3s ease',
                '&:hover': {
                  color: theme.colors.primary,
                  transform: 'translateY(-2px)',
                },
              }}
            >
              {link.icon_name === 'DiscordIcon' ? (
                <SiDiscord size={size === 'small' ? 18 : size === 'large' ? 28 : 22} />
              ) : (
                <IconComponent fontSize={size} />
              )}
            </IconButton>
          </Tooltip>
        );
      })}
    </Stack>
  );
};

export default SocialLinks;
